import React, { useState, useEffect } from 'react';
import './cookiepopup.css';

const CookiePopup = () => {
  const [showCookies, setShowCookies] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowCookies(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setShowCookies(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'false');
    setShowCookies(false);
  };

  if (!showCookies) {
    return null;
  }

  return (
    <>
    <div className="cookie-card">
      <div className='row justify-content-between align-items-center'> 

        <div className='col-md-6 col-sm-12'> 
          <div className="title"><i className="bi bi-check2-circle me-1 verified-badge"></i> Cookie Consent!</div>
          <p className="description">
            We use cookies to enhance your experience. By continuing to browse, you agree to our use of cookies.
          </p>
        </div>

      <div className='col-md-6 col-sm-12'> 
        <div className="row justify-content-md-end align-items-center">
          <div className="col-auto mb-md-0 mb-sm-3 text-md-end">
              <button className="btn text-primary-outline me-5" onClick={handleReject}>
              Deny Cookies
              </button>
          </div>

          <div className="col-auto text-md-end ">
              <button className="btn btn-outline-primary" onClick={handleAccept}>
              Accept Cookies
              </button>
          </div> 
        </div>
      </div>

  </div>

    </div>
    <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default CookiePopup;
